import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';

export const generateReferralCode = (userId: string): string => {
  return `ANI${userId.slice(0, 6).toUpperCase()}`;
};

export const createReferral = async (referrerId: string, referredUserId: string) => {
  const referralData = {
    referrerId,
    referredUserId,
    status: 'pending',
    createdAt: Timestamp.now(),
  };

  await addDoc(collection(db, 'referrals'), referralData);
};

export const getReferralsCount = async (userId: string): Promise<number> => {
  const q = query(
    collection(db, 'referrals'),
    where('referrerId', '==', userId)
  );
  const querySnapshot = await getDocs(q);
  return querySnapshot.size;
};

export const applyReferralCode = async (code: string, newUserId: string) => {
  // Extract user ID from code
  const referrerId = code.replace('ANI', '').toLowerCase();
  
  // Verify referrer exists
  const userRef = doc(db, 'users', referrerId);
  const userDoc = await getDoc(userRef);
  
  if (userDoc.exists()) {
    await createReferral(referrerId, newUserId);
    return true;
  }
  
  return false;
};